import axios from 'src/libs/axios';
import { QueryFunctionContext } from '@tanstack/react-query';

const getChamfer = (args: QueryFunctionContext<any>) => {
  const [url, params] = args.queryKey;

  return axios({
    method: 'get',
    url,
    params: {
      fraiseKakoMensu: params,
    },
  });
};

export default { getChamfer };
